import { Button, Modal } from 'antd';
import { t } from 'i18next';
import React from 'react';
import IconSave from '../../../assets/Images/icons/icon-save';

const ModalSave = ({
    open,
    text = 'Lorem ipsum dolor sit amet',
    handelClose,
    handelOk,
    loading,
}) => {
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                <IconSave />
                <div className="text-2xl font-semibold">
                    {t('common.ConfirmSave')}
                </div>
                <div>{text}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button
                    type="primary"
                    onClick={handelClose}
                    size="large"
                    ghost
                    className="w-36"
                >
                    {t('common.Cancel')}
                </Button>

                <Button
                    loading={loading}
                    onClick={handelOk}
                    size="large"
                    type="primary"
                    className="w-36"
                >
                    {t('common.Confirm')}
                </Button>
            </div>
        </Modal>
    );
};
export default ModalSave;
